export default __webpack_public_path__ + "static/media/thrivebox.d36f146e.png";